<div class="folder-picker-node" [class.selected]="selectedNode === node" (click)="select()">
  <button type="button" class="folder-picker-toggle" (click)="toggle($event)">
    <i [class]="node.expanded ? 'nxe-angle-down' : 'nxe-angle-right'"></i>
  </button>
  <i class="nxe-folder"></i>
  <span class="folder-picker-name">{{ node.name }}</span>
</div>

@if (node.expanded) {
  <div class="folder-picker-children">
    @for (child of node.children; track child.path) {
      <app-document-folder-tree-node [node]="child" [selectedNode]="selectedNode" (nodeSelected)="onChildSelected($event)" />
    }
  </div>
}
